export default class APIError extends Error {
  errors;

  constructor(errors) {
    super('APIError');
    Object.setPrototypeOf(this, APIError.prototype);
    this.errors = errors;
  }
}
